import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';

export class UnassignTagsActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  protected canRunOnMultipleCompanies = false;

  private allowedUnconditionallyTypes = [
    Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER_GROUP,
    Constants.ProtectedEntities.EPS.TYPE_CUSTOM_GROUP,
  ];

  private allowedTypes = [
    Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER,
    Constants.ProtectedEntities.EPS.TYPE_COMPUTER,
    Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER_GROUP,
    Constants.ProtectedEntities.EPS.TYPE_CUSTOM_GROUP,
    Constants.ProtectedEntities.EPS.VMWARE_HOST_SYSTEM,
    Constants.ProtectedEntities.EPS.VMWARE_FOLDER,
    Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_MACHINE,
  ];

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (this.allowedTypes.indexOf(record.type) < 0) {
      return false;
    }

    if (!!record.specifics.isSva) {
      return false;
    }

    if (record.specifics.isManaged === false) {
      return false;
    }

    if (this.allowedUnconditionallyTypes.indexOf(record.type) >= 0) {
      return true;
    }

    if (record.specifics.gzTagIds && record.specifics.gzTagIds.length > 0) {
      return true;
    }

    return false;
  }
}
